/**
 * @file
 * A utilities class.
 */

export default {
  // Fix the Gutenberg block display for web components. For some reason, custom
  // HTML elements (e.g. <core-swiper>) with the 'class' attribute get changed
  // to 'classname' after rendering in the editor. Harmless on the front-end.
  classnameFix($el) {
    const classname = $el.getAttribute('classname')
    if (classname) {
      $el.setAttribute('class', classname)
      $el.removeAttribute('classname')
    }
  },
  isMobile() {
    return window.matchMedia('(max-width: 859px)').matches
  },
  unwrap(element) {
    const parent = element.parentNode

    // Move all children out of the element.
    while (element.firstChild) parent.insertBefore(element.firstChild, element)

    // Remove the empty element.
    parent.removeChild(element)
  },
  wrap(element, wrapper) {
    element.parentNode.insertBefore(wrapper, element)
    wrapper.appendChild(element)
  },
}
